import { useQuery } from "@tanstack/react-query";
import api from "../services/newApi/api";

export const useAuthFeatureFlag = (key: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["auth-feature-flags", key],
    queryFn: async () => {
      const response = await api.get<{
        status: string;
        data: { key: string; enabled: boolean };
      }>(`/feature-flags/${key}`);
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    enabled: isLoading ? false : (data?.enabled ?? false),
    loading: isLoading,
  };
};
